import Routing from "routing";

import type { GlobalSearchResponse } from "../results/types";

type RequestOptions = { signal?: AbortSignal };

export interface CommandPaletteApi {
  fetchGlobalSearch(
    query: string,
    types: string[],
    ids: number[],
    limit: number,
    options?: RequestOptions,
  ): Promise<GlobalSearchResponse>;
}

export const commandPaletteApi: CommandPaletteApi = {
  async fetchGlobalSearch(query, types, ids, limit, options) {
    const uri = Routing.generate("api_search_global_filter");

    const response = await fetch(uri, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filter: {
          q: query,
          types: types.length > 0 ? types : null,
          ids: ids.length > 0 ? ids : null,
          limit,
        },
      }),
      ...options,
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch search results: ${response.statusText}`);
    }

    return response.json();
  },
};
